import React from 'react';
import type { VacationRequest } from '../../models/vacation.types';
import type { VacationPeriod } from '@/features/Collaborators/Edit/Types';
import { HistoryEntry } from './components/HistoryEntry';
import { ManualPeriodsSection } from './components/ManualPeriodsSection';
import { HISTORY_EMPTY, HISTORY_SECTION_TITLE } from './vacationRequestHistory.definitions';

interface VacationRequestHistoryProps {
  requests: VacationRequest[];
  vacationPeriods?: VacationPeriod[];
}

export function VacationRequestHistory({
  requests,
  vacationPeriods = [],
}: VacationRequestHistoryProps) {
  // Filtrar rascunhos e ordenar por data de decisão decrescente
  const filtered = requests
    .filter((r) => r.status !== 'Draft')
    .sort((a, b) => {
      const aDate = a.dpApproval?.at || a.requestedAt;
      const bDate = b.dpApproval?.at || b.requestedAt;
      if (!aDate || !bDate) return 0;
      return new Date(bDate.toDate()).getTime() - new Date(aDate.toDate()).getTime();
    });

  const hasRequests = filtered.length > 0;
  const hasManualPeriods = vacationPeriods && vacationPeriods.length > 0;

  return (
    <div className="space-y-4">
      {!hasRequests && !hasManualPeriods && (
        <p className="text-sm text-gray-500">{HISTORY_EMPTY}</p>
      )}

      {hasRequests && (
        <div>
          <h3 className="text-sm font-semibold text-gray-900 mb-3">{HISTORY_SECTION_TITLE}</h3>
          <div className="space-y-2">
            {filtered.map((request) => (
              <HistoryEntry key={request.id} request={request} />
            ))}
          </div>
        </div>
      )}

      <ManualPeriodsSection periods={vacationPeriods} />
    </div>
  );
}
